import React from "react";
// import './EnergyPageCustom_Bus.css'
import DashboardMain_Bus from "../DashboardMain_Bus/DashboardMain_Bus";
import * as $ from "jquery";
import { useCallback, useContext, useEffect, useState } from "react";
import { INIT_FILTER_STATE_PDF } from "../../../constants/driveglobalfilterinitalstates_bus";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import useHttp from "../../../hook/use-http";
import { decodeToken } from "react-jwt";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";
import PdfFilter_Bus from "./PdfFilter_Bus";
import PdfFirstPage_Bus from "./PdfFirstPage_Bus";

export default function PdfPage_Bus() {
  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const city_name = decodedToken.city_name;
  const city_name_arr = city_name.split(",");
  const depo_name = decodedToken.depo_name;
  const depo_name_arr = depo_name.split(",");
  let sampleObj =
    city_name != ""
      ? { ...INIT_FILTER_STATE_PDF, CITY: city_name_arr, DEPO: depo_name_arr }
      : INIT_FILTER_STATE_PDF;
  const [gloablfilter, setGloablfilter] = useState(sampleObj);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [showLoader, setShowLoader] = useState(false);

  const log_data = (data) => {};

  useEffect(() => {
    window.$("#button-1_Bus").checked = false;
    fetchData(
      {
        url: API_URL_MAIN + "auth/logging",
        body: {
          page_name: "performance_report_bus",
        },
      },
      log_data
    );
  }, []);

  const [fromTableToFilter_vin, setFromTableToFilter_vin] = useState(0);
  const filterSubmited = useCallback((data) => {
    if (data.VIN_NUM.length === 1) {
      setFromTableToFilter_vin(data.VIN_NUM[0]);
    }
    setGloablfilter(data);
  }, []);

  const onreset = (data) => {
    setGloablfilter(data);
  };

  const [selectedtemp, setSelectedTemp] = useState(45);
  const onpack = (data) => {
    setSelectedTemp(data);
  };

  const [buttonClick, setButtonClick] = useState("");
  const buttonClicked = (data) => {
    setButtonClick(data);
  };

  const buttonDisable = (data) => {
    setButtonClick(data);
  };

  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <DashboardMain_Bus>
        <div
          className="main_hole_background"
          style={{ backgroundColor: "", minHeight: "90vh" }}
        >
          <PdfFilter_Bus
            onsubmit={filterSubmited}
            gloablfilter={gloablfilter}
            onreset={onreset}
            onpack={onpack}
            buttonClicked={buttonClicked}
            showLoader={showLoader}
            setShowLoader={setShowLoader}
          />

          <PdfFirstPage_Bus
            gloablfilter={gloablfilter}
            selectedtemp={selectedtemp}
            buttonClick={buttonClick}
            buttonDisable={buttonDisable}
            showLoader={showLoader}
            setShowLoader={setShowLoader}
          />
        </div>
      </DashboardMain_Bus>
    </>
  );
}
